import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { AnimatePresence } from 'framer-motion';
import './assets/scss/app.scss';

import Header from './components/Header';
import Menu from './components/Menu';
import PageTransitionWrap from './components/PageTransitionWrap';
import Index from './routes/index';
import DetailPage from './routes/detailPage';

import { getTempleData } from './store/templesReducer';

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => dispatch(getTempleData()), []);

  return (
    <div className="app">
      <Header></Header>
      <Menu></Menu>
      <AnimatePresence exitBeforeEnter>
        <Routes key={location.pathname} location={location}>
          <Route path="/" element={<PageTransitionWrap><Index /></PageTransitionWrap>}></Route>
          <Route path="/:detailId" element={<PageTransitionWrap><DetailPage /></PageTransitionWrap>}></Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnimatePresence>
    </div>
  );
}

export default App;
